import { RUNNING_INTENSITY_ZONES } from "./constants";

const toNumber = (value) => {
    const parsed = Number(String(value || "").replace(",", "."));
    return Number.isFinite(parsed) ? parsed : 0;
};

const distanceToKm = (distance, unit = "km") => {
    const value = toNumber(distance);
    if (unit === "m") return value / 1000;
    return value;
};

export const calculateRunningSegmentDistanceKm = (segment = {}) => {
    if (segment.durationType !== "distance") return 0;
    const reps = Math.max(1, toNumber(segment.reps) || 1);
    return reps * distanceToKm(segment.distance, segment.distanceUnit);
};

export const calculateRunningSegmentDurationMin = (segment = {}) => {
    if (segment.durationType !== "time") return 0;
    const reps = Math.max(1, toNumber(segment.reps) || 1);
    return reps * toNumber(segment.duration);
};

export const calculateRunningBlockSummary = (block = {}) => {
    const segments = block.sets || [];
    const repeat = Math.max(1, toNumber(block.repeat) || 1);
    const baseDistanceKm = segments.reduce((total, segment) => total + calculateRunningSegmentDistanceKm(segment), 0);
    const baseDurationMin = segments.reduce((total, segment) => total + calculateRunningSegmentDurationMin(segment), 0);
    const zoneMap = {};

    segments.forEach((segment) => {
        const zone = segment.effortZone || "z2";
        const distanceKm = calculateRunningSegmentDistanceKm(segment) * repeat;
        const durationMin = calculateRunningSegmentDurationMin(segment) * repeat;
        zoneMap[zone] = {
            distanceKm: (zoneMap[zone]?.distanceKm || 0) + distanceKm,
            durationMin: (zoneMap[zone]?.durationMin || 0) + durationMin,
        };
    });

    return {
        distanceKm: baseDistanceKm * repeat,
        durationMin: baseDurationMin * repeat,
        segmentsCount: segments.length,
        repeats: repeat,
        zones: RUNNING_INTENSITY_ZONES
            .map(zone => ({ ...zone, ...(zoneMap[zone.value] || { distanceKm: 0, durationMin: 0 }) }))
            .filter(zone => zone.distanceKm > 0 || zone.durationMin > 0),
    };
};

export const calculateRunningWorkoutSummary = (workout = {}) => {
    const blocks = workout.blocks || [];
    return blocks.reduce((summary, block) => {
        const blockSummary = calculateRunningBlockSummary(block);
        return {
            distanceKm: summary.distanceKm + blockSummary.distanceKm,
            durationMin: summary.durationMin + blockSummary.durationMin,
            segmentsCount: summary.segmentsCount + blockSummary.segmentsCount,
            blocksCount: summary.blocksCount + 1,
        };
    }, {
        distanceKm: 0,
        durationMin: 0,
        segmentsCount: 0,
        blocksCount: 0,
    });
};
